"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Rating_1 = __importDefault(require("@mui/material/Rating"));
const react_1 = __importDefault(require("react"));
const Rating = ({ name = 'rating', precision = 0.5, ...restProps }) => (react_1.default.createElement(Rating_1.default, { name: name, precision: precision, ...restProps }));
exports.default = Rating;
